import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

interface Props {
  id: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  minLength?: number;
  autoComplete?: string;
  /** Clase del input; por defecto el tamaño normal de Bootstrap. */
  className?: string;
  onSubmitEnter?: () => void;
}

/**
 * Campo de contraseña con el ojo para revelarla.
 * Escribir a ciegas es incómodo en el escritorio y directamente un problema en
 * el teléfono, donde el teclado táctil hace errar seguido.
 */
const PasswordInput: React.FC<Props> = ({
  id,
  value,
  onChange,
  placeholder,
  required,
  disabled,
  minLength,
  autoComplete = 'current-password',
  className = 'form-control',
  onSubmitEnter
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="input-group">
      <input
        id={id}
        type={visible ? 'text' : 'password'}
        className={className}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        minLength={minLength}
        autoComplete={autoComplete}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && onSubmitEnter) onSubmitEnter();
        }}
      />
      <button
        type="button"
        className="btn btn-outline-secondary"
        onClick={() => setVisible((v) => !v)}
        disabled={disabled}
        aria-label={visible ? 'Ocultar contraseña' : 'Mostrar contraseña'}
        aria-pressed={visible}
        title={visible ? 'Ocultar contraseña' : 'Mostrar contraseña'}
      >
        {visible ? <FaEyeSlash /> : <FaEye />}
      </button>
    </div>
  );
};

export default PasswordInput;
